export const SET_GLOBAL_REPAIR_SERVICES = 'SET_GLOBAL_REPAIR_SERVICES';
export const CLEAR_GLOBAL_REPAIR_SERVICES = 'CLEAR_GLOBAL_REPAIR_SERVICES';



// WEBPACK FOOTER //
// ./src/store/reducers/globalRepair/actionTypes.js